import { useState } from "react";
import { createData } from "./DataDisplay";

export let milling_data = [createData("Map Example","Hwy 555","LT",244,1000,82,82000,2,100,15,"yes")];


export let spread_rate  = [100];

